import { adapterFeatureSettings } from './settingAdapter'
import { settingApi } from './settingApi'
import {
  AdaptedFeaturesSettingsDTO,
  FeaturesSettingsAdapterParams,
} from './settingTypes'

async function getFeaturesSettings(
  adapterParams?: FeaturesSettingsAdapterParams,
): Promise<AdaptedFeaturesSettingsDTO> {
  const featureSettings = await settingApi.getFeaturesSettings()

  return adapterFeatureSettings(featureSettings, adapterParams)
}

export const settingServices = {
  getFeaturesSettings,
}
